import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { AppState } from "../../state/models";
import { PromiseDispatch } from "../../state/models/types";

export const useShallowEqualSelector = <ReturnType>(
  selector: (state: AppState) => ReturnType,
) => useSelector<AppState, ReturnType>(selector, shallowEqual);

export const useDispatchPromise = (): PromiseDispatch => useDispatch<PromiseDispatch>();
